<app-header></app-header>



<div class="container text-center" style="padding: 1rem 1rem;">
    <div class="d-flex justify-content-center">
        <img src="/assets/404-error.png" alt="">     
    </div>
    <h1 class="missing-page mt-3 mb-3">Something went wrong!</h1>
    <p>The page you were looking for doesn't exist</p>
</div>



<app-footer></app-footer>